export const getManifestations = (eresourceid: string) => {
  const query = `
  SELECT DISTINCT ?manifestation ?manifestationTitle
  WHERE {
    <${eresourceid}> <http://scta.info/property/hasManifestation> ?manifestation .
    ?manifestation <http://purl.org/dc/elements/1.1/title> ?manifestationTitle .
  }
  `
  return query
}